import { render, staticRenderFns } from "./FlightFares.vue?vue&type=template&id=dc21e20a&scoped=true&"
import script from "./FlightFares.vue?vue&type=script&lang=js&"
export * from "./FlightFares.vue?vue&type=script&lang=js&"
import style0 from "./FlightFares.vue?vue&type=style&index=0&id=dc21e20a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc21e20a",
  null
  
)

export default component.exports